var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.index,staticClass:"jiugonggeBox"},[(_vm.v_if)?_c('div',{ref:"thanks",staticClass:"thanks"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }